import { getMediaClientErrorReason, isRequestError } from '@atlaskit/media-client';
import { getFileStateErrorReason, ImageLoadError, isMediaFilePreviewError, isMediaFileStateError } from './errors';
export const getErrorTraceContext = error => {
  if (isMediaFilePreviewError(error) && !!error.secondaryError) {
    if (isRequestError(error.secondaryError)) {
      var _error$secondaryError;
      return (_error$secondaryError = error.secondaryError.metadata) === null || _error$secondaryError === void 0 ? void 0 : _error$secondaryError.traceContext;
    } else if (isMediaFileStateError(error.secondaryError)) {
      var _error$secondaryError2, _error$secondaryError3;
      return (_error$secondaryError2 = error.secondaryError.details) === null || _error$secondaryError2 === void 0 ? void 0 : (_error$secondaryError3 = _error$secondaryError2.metadata) === null || _error$secondaryError3 === void 0 ? void 0 : _error$secondaryError3.traceContext;
    }
  }
};
export const getRenderErrorFailReason = error => {
  if (isMediaFilePreviewError(error)) {
    return error.primaryReason;
  } else {
    return 'nativeError';
  }
};
export const getRenderErrorErrorReason = error => {
  if (isMediaFilePreviewError(error) && error.secondaryError) {
    const mediaClientReason = isMediaFileStateError(error.secondaryError) ? getFileStateErrorReason(error.secondaryError) : getMediaClientErrorReason(error.secondaryError);
    if (mediaClientReason !== 'unknown') {
      return mediaClientReason;
    }
  }
  return 'nativeError';
};
export const getRenderErrorErrorDetail = error => {
  if (isMediaFilePreviewError(error) && error.secondaryError) {
    return error.secondaryError.message;
  } else {
    return error.message;
  }
};
export const extractErrorInfo = (error, metadataTraceContext) => {
  return {
    failReason: getRenderErrorFailReason(error),
    error: getRenderErrorErrorReason(error),
    errorDetail: getRenderErrorErrorDetail(error),
    metadataTraceContext: metadataTraceContext !== null && metadataTraceContext !== void 0 ? metadataTraceContext : getErrorTraceContext(error)
  };
};
export const createFailedSSRObject = (preview, metadataTraceContext) => ({
  status: 'fail',
  ...extractErrorInfo(new ImageLoadError(preview.source), metadataTraceContext)
});